import { initialStrollersSearchState } from "@/mk2/apps/strollers/containers/StrollersSearch/StrollersSearch.reducers";
import { AppState } from "@/mk2/reducers";

export const getStrollersSearchState = (state: AppState) =>
    (state.containers.strollers && state.containers.strollers.strollersSearch) ||
    initialStrollersSearchState;
